import { useAppDispatch } from 'app/hooks';
import { ExistingSystemType } from 'data/types';
import { pruneOrphanedDuctedPairLinks } from 'features/configurations';
import { removeExistingSystem } from 'features/structure/structure-slice';
import { useCallback } from 'react';
import {
  deleteExistingSystemPhotos,
  REMOVE_SYSTEM_CONFIRM_BUTTON_TEXT,
  REMOVE_SYSTEM_CONFIRM_TITLE,
  removeExistingSystemConfirmationMessage
} from 'utils/existing-system-removal';
import { confirmationModal } from 'utils/ui';

export default function useRemoveExistingSystem() {
  const dispatch = useAppDispatch();

  return useCallback(
    (system: ExistingSystemType) => {
      const remove = async () => {
        await deleteExistingSystemPhotos(system);
        dispatch(removeExistingSystem({ uniqueId: system.uniqueId }));
        dispatch(pruneOrphanedDuctedPairLinks());
      };
      if (system.components.length === 0) {
        remove();
        return;
      }
      confirmationModal(
        removeExistingSystemConfirmationMessage(system),
        remove,
        REMOVE_SYSTEM_CONFIRM_TITLE,
        'Cancel',
        REMOVE_SYSTEM_CONFIRM_BUTTON_TEXT
      );
    },
    [dispatch]
  );
}
